// JavaScript Document
$(function(){
$(".a-inner").hide();
	$(".qa-con dl").on("click", function(e){
		$('.a-inner',this).slideToggle('fast');
		if($('.q-headding',this).hasClass('open')){
			$('.q-headding',this).removeClass('open');
		}else{
			$('.q-headding',this).addClass('open');
		}
	});
});